/*
 * @Author: jiurigege
 * @Date: 2019-07-31 14:32:43
 * @Last Modified by: jiurigege
 * @Last Modified time: 2019-09-19 20:23:14
 */
/* eslint-disable */

import config from '../../constant/config';

// 获取链接上的参数
export const getLinkParams = (params) => {
  var paramsArr = location.search.substring(1).split('&');
  var paramsObj = {};
  paramsArr.forEach((val) => {
    const thisArr = val.split('=');
    paramsObj[thisArr[0]] = thisArr[1];
  }, this);
  return paramsObj[params] || '';
};

// 判断客户端类型
export const checkMobile = () => {
  if (process.server) {
    return {
      isAndroid: () => false,
      isIos: () => false,
      isPC: () => false,
      isX: () => false
    };
  }
  const u = process.client ? navigator.userAgent : '';
  const isAndroid = () => u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  const isIos = () => u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const isPC = () => {
    const Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod'
    ];
    let res = true;
    for (let v = 0; v < Agents.length; v += 1) {
      if (u.indexOf(Agents[v]) > 0) {
        res = false;
        break;
      }
    }
    return res;
  };
  const isX = () =>
    /iphone/gi.test(u) &&
    ((screen.height === 812 && screen.width === 375) ||
      (screen.height === 896 && screen.width === 414));
  return {
    isAndroid: isAndroid,
    isIos: isIos,
    isPC: isPC,
    isX: isX
  };
};

// xhr请求封装
export const $ajax = (options) => {
  function formatParams(data) {
    let arr = [];
    for (let k in data) {
      arr.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k]));
    }
    return arr.join('&');
  }
  options = options || {};
  options.type = (options.type || 'GET').toUpperCase();
  options.dataType = options.dataType || 'json';
  options.params = formatParams(options.data);
  options.withCredentials = options.withCredentials || false;
  const xhr = new XMLHttpRequest();
  if (options.type === 'GET') {
    xhr.open('GET', `${options.url}?${options.params}`, true);
    xhr.send(null);
  } else if (options.type === 'POST') {
    xhr.open('POST', options.url, true);
    xhr.withCredentials = options.withCredentials;
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(options.params);
  }

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status >= 200) {
      options.success && options.success(xhr.responseText, xhr.responseXML);
    } else {
      options.error && options.error(status);
    }
  };
};

// jsonp封装
export const jsonp = (url, name, callback) => {
  const cbName =
    name +
    Math.random()
      .toString()
      .replace('.', '');
  const scriptEle = document.createElement('script');
  scriptEle.src = url + cbName;
  window[cbName] = function(data) {
    callback(data);
    document.body.removeChild(scriptEle);
  };
  document.body.appendChild(scriptEle);
};

// 复制到剪切板
export const copyToClipboard = (el) => {
  if (el.select) {
    el.select();
  } else {
    var selection = window.getSelection();
    var createRange = document.createRange();
    createRange.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(createRange);
    document.execCommand('copy');
    selection.removeAllRanges();
  }
};

// 是否全屏
export const getIsFullScreen = () => {
  if (!process.client) {
    return;
  }

  const doc = window.document;

  return !(
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  );
};

// 全屏切换
export const toggleFullScreen = (el) => {
  if (!process.client) {
    return;
  }
  const doc = window.document;
  const docEl = el || doc.documentElement;

  const requestFullScreen =
    docEl.requestFullscreen ||
    docEl.mozRequestFullScreen ||
    docEl.webkitRequestFullScreen ||
    docEl.webkitEnterFullscreen ||
    docEl.msRequestFullscreen;
  const cancelFullScreen =
    doc.exitFullscreen ||
    doc.mozCancelFullScreen ||
    doc.webkitExitFullscreen ||
    doc.msExitFullscreen;

  if (
    !doc.fullscreenElement &&
    !doc.mozFullScreenElement &&
    !doc.webkitFullscreenElement &&
    !doc.msFullscreenElement
  ) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};

// 根据平台来源获取对应配置
export const getLiveConfig = (app) => {
  return config[app];
};
